export default function Visit() {
  return (
    <section id="visit" className="relative bg-foreground-950 text-background-50 py-24 md:py-36 overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute top-1/3 left-1/4 w-[600px] h-[600px] rounded-full opacity-[0.05] pointer-events-none animate-halo"
        style={{ background: "radial-gradient(circle, oklch(var(--accent-500)), transparent 70%)" }} />

      <div className="px-6 md:px-12 max-w-7xl mx-auto relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Info */}
          <div>
            <p className="font-display text-xs uppercase tracking-[0.25em] text-background-50/60 mb-6">
              ( Visit ) — The Studio
            </p>
            <h2 className="font-display font-black text-background-50 leading-[0.85] tracking-[-0.04em] text-[12vw] md:text-[7vw] lg:text-[5.5vw] mb-10">
              Find the <em className="font-serif italic font-light">sanctuary</em>.
            </h2>

            <div className="space-y-8">
              <div>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-background-50/50 mb-2">Address</p>
                <p className="text-background-50 text-lg font-serif leading-relaxed">
                  14 South Union Avenue<br />
                  Cranford, New Jersey 07016
                </p>
              </div>

              <div>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-background-50/50 mb-2">Hours</p>
                <div className="space-y-2 text-background-50/90 font-serif">
                  <p>Tuesday — Saturday: 11:00 AM — 7:00 PM</p>
                  <p>Sunday — Monday: By Appointment Only</p>
                </div>
              </div>

              <div>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-background-50/50 mb-2">Contact</p>
                <div className="space-y-2">
                  <a href="mailto:hello@fineartstattoo.com" className="block link-underline text-background-50 cursor-pointer font-serif">
                    hello@fineartstattoo.com
                  </a>
                  <a href="tel:+19085550182" className="block link-underline text-background-50 cursor-pointer font-serif">
                    +1 (908) 555-0182
                  </a>
                </div>
              </div>

              <div>
                <p className="font-display text-[10px] uppercase tracking-[0.25em] text-background-50/50 mb-2">Directions</p>
                <p className="text-background-50/70 font-serif text-sm leading-relaxed">
                  Located in the heart of downtown Cranford, steps from the Raritan Valley Line station. Street parking available on Union Avenue and nearby municipal lots. The studio entrance is marked by a bronze plaque beside the walnut doorway.
                </p>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="w-full h-[400px] md:h-[500px] rounded-md overflow-hidden border border-background-50/15">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3028.123456789!2d-74.2999!3d40.6584!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDM5JzMwLjIiTiA3NMKwMTcnNTkuNiJX!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Fine Arts Tattoo Collective — Cranford, NJ"
              className="grayscale contrast-75"
            />
          </div>
        </div>
      </div>
    </section>
  );
}